export const LogError = (query, params, error) => {
  console.error(
    `Trying to fetch data with query '${query}' and params '${params}' resulted in an error: ${error}`,
  );
};
